// extracted by mini-css-extract-plugin
export default {"page":"style_page__gr8kk","container":"style_container__1bAV2","imageContainer":"style_imageContainer__gjtQ9"};